import * as TYPES from '../types';
import { JSON_HEADER, AUTH_HEADER } from '../../config';
import { removeTokens } from '../../store/localStorage';
import { Notification } from './../../common/notification/notifications';
import { SUBSCRIBER, COMMON } from '../../constants/index';
import { jwtDecode } from 'jwt-decode';
import * as authProvider from '../../authProvider.js';

export default ({ dispatch, getState }) =>
    (next) =>
    async (action) => {
        const { auth } = getState();
        if (action.type !== TYPES.APIREQUEST) {
            return next(action);
        }
        let accToken = await authProvider.getAccessToken().then((response) => {
            return response?.accessToken;
        });
        const {
            method,
            server,
            extraHeaderObject,
            endpoint,
            onload,
            onsuccess,
            onerror,
            body,
            title = '',
            showLoader = true
        } = action.payload;
        const headers = Object.assign(
            {},
            JSON_HEADER,
            AUTH_HEADER(accToken),
            extraHeaderObject || {}
        );
        try {
            if (showLoader) {
                dispatch(onload(title));
            }
            const config = {
                method,
                headers
            };
            if (!headers && server) {
                config.headers = Object.assign(
                    {},
                    AUTH_HEADER(auth[server]),
                    JSON_HEADER
                );
            }
            if (
                method === 'POST' ||
                method === 'PATCH' ||
                method === 'DELETE' ||
                method === 'PUT'
            ) {
                config.body = body;
            }

            let decoded = jwtDecode(headers.Authorization);
            if (Date.now() >= decoded.exp * 1000) {
                window.dispatchEvent(new CustomEvent('show-logout-modal'));
                removeTokens();
                return;
            } else {
                const res = await fetch(endpoint, config);

                if (
                    (res.url.includes('invitations') ||
                        res.url.includes('markRefund')) &&
                    res.status === 200
                ) {
                    dispatch(
                        onsuccess({
                            statusCode: 200,
                            statusMessage: 'Invitation Successfully Sent !'
                        })
                    );
                    return;
                } else if (
                    method === 'POST' &&
                    res.status === 200 &&
                    res.url.includes('offers/vendor')
                ) {
                    dispatch(
                        onsuccess({
                            statusCode: 200,
                            statusMessage: 'Offer Created Successfully'
                        })
                    );
                    return;
                } else if (
                    method === 'PATCH' &&
                    res.status === 204 &&
                    res.url.includes('admin/vendor')
                ) {
                    dispatch(
                        onsuccess({
                            statusCode: 204,
                            statusMessage: 'Vendor Updated Successfully'
                        })
                    );
                    return;
                }

                if (res.status === 204) {
                    dispatch(onsuccess({ statusCode: 204 }));
                }

                const response = await res.json();

                if (response.non_field_errors) {
                    dispatch(onerror(response.non_field_errors[0], title));
                } else if (response.detail) {
                    dispatch(onerror(response.detail, title));
                } else if (
                    response.statusCode === 400 ||
                    response.statusCode === 409 ||
                    response.statusCode === 403 ||
                    response.statusCode === 404
                ) {
                    dispatch(onerror(response, title));
                } else if (response.status === 500) {
                    Notification(SUBSCRIBER.error, COMMON.commonServerError);
                    dispatch(onerror(response, title));
                } else if (response.statusCode === 401) {
                    dispatch(onerror(response, title));
                    window.dispatchEvent(new CustomEvent('show-logout-modal'));
                    removeTokens();
                } else {
                    dispatch(onsuccess(response));
                }
            }
        } catch ({ message }) {
            dispatch(onerror(message, title));
        }
    };

export const request = async (data) => {
    const { endpoint, body, token, method, headers } = data;
    const config = {
        method: method,
        headers: headers
            ? headers
            : Object.assign({}, AUTH_HEADER(token), JSON_HEADER),
        body
    };
    try {
        return await (await fetch(`${endpoint}`, config)).json();
    } catch (err) {
        throw err;
    }
};
